export default "__VITE_ASSET__B8WK0vrC__"